<template>
  <div>
    <div class="content-bottom-padded">
      <el-alert type="info" title="下载提示" show-icon >
          <div>
            已经生成的文件只保留一天，请及时下载
          </div>
      </el-alert>
    </div>
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" tab-position="right" style="height: 740px !important;">
      <el-tab-pane label="实体主订单导出" name="normal_master_order"></el-tab-pane>
      <el-tab-pane label="实体子订单导出" name="normal_order"></el-tab-pane>
      <el-tab-pane label="优选订单" name="yibei_order"></el-tab-pane>
      <el-tab-pane label="优卡交易明细" name="yibei_benfit_advance"></el-tab-pane>
      <el-tab-pane label="优选资金明细" name="yibei_member_advance"></el-tab-pane>
      <el-tab-pane label="员工佣金明细" name="yibei_staff_commission_detail"></el-tab-pane>
      <el-tab-pane label="团长奖励待发放" name="sharer_reward_pending"></el-tab-pane>
      <el-tab-pane label="优选会员" name="yibei_members"></el-tab-pane>
      <el-tab-pane label="优选推客排行" name="yibei_tuike"></el-tab-pane>
      <el-tab-pane label="优选分享点击" name="yibei_click"></el-tab-pane>
      <el-tab-pane label="优选商品" name="yibei_sku"></el-tab-pane>
      <el-tab-pane label="优选提现" name="yibei_tixian"></el-tab-pane>
      <el-tab-pane label="优选员工提现工资" name="yibei_stafftixian"></el-tab-pane>
      <el-tab-pane label="加盟员工单提奖励" name="yibei_franchise_staff_tixian_data"></el-tab-pane>
      <el-tab-pane label="优选合伙人" name="yibei_hhmember"></el-tab-pane>
      <el-tab-pane label="优选分享签到" name="yibei_qiandao"></el-tab-pane>
      <el-tab-pane label="会员开卡" name="kaika_info"></el-tab-pane>
      <el-tab-pane label="会员导出" name="member"></el-tab-pane>
      <el-tab-pane label="商品数据导出" name="goods_data"></el-tab-pane>
      <el-tab-pane label="服务订单导出" name="service_order"></el-tab-pane>
      <el-tab-pane label="交易单导出" name="tradedata"></el-tab-pane>
      <el-tab-pane label="对账单导出" name="statementdata"></el-tab-pane>
      <el-tab-pane label="售后列表导出" name="aftersale_record_count"></el-tab-pane>
      <el-tab-pane label="销售数据导出" name="finance_data"></el-tab-pane>
      <el-tab-pane label="退款数据(订单)导出" name="refund_data"></el-tab-pane>
      <el-tab-pane label="退款数据(时间)导出" name="aftersales_refund_data"></el-tab-pane>
      <el-tab-pane label="多店铺实名数据导出" name="realnames_data"></el-tab-pane>
      <el-tab-pane label="商城实名数据导出" name="shoprealnames_data"></el-tab-pane>
      <el-tab-pane label="货号交易明细导出" name="artno_data"></el-tab-pane>
      <el-tab-pane label="商品列表导出" name="items_data"></el-tab-pane>
      <el-tab-pane label="药关爱" name="Yga_data"></el-tab-pane>
	    <el-tab-pane label="厂家财务对账" name="manu_report_from"></el-tab-pane>
      <el-tab-pane label="药品需求单" name="drug_order"></el-tab-pane>
      <el-tab-pane label="权益导出" name="right"></el-tab-pane>
      <el-tab-pane label="权益核销记录导出" name="right_consume"></el-tab-pane>
      <el-tab-pane label="代客找药" name="find_data"></el-tab-pane>
      <el-tab-pane label="燕尾帽订单" name="ywm_data"></el-tab-pane>
      <el-tab-pane label="直播数据导出" name="live_data"></el-tab-pane>
      <el-tab-pane label="直播标题导出" name="live_title"></el-tab-pane>
      <el-tab-pane label="视频红包领取详情" name="live_marking_log"></el-tab-pane>
      <el-tab-pane label="视频红包统计报表" name="live_marking_count_log"></el-tab-pane>
      <el-tab-pane label="社区团购-积分提现记录导出" name="community_withdraw"></el-tab-pane>
      <el-tab-pane label="平台统计列表导出" name="platform_data"></el-tab-pane>
      <el-tab-pane label="优惠券下载卡号导出" name="kaquan_code_data"></el-tab-pane>
      <el-tab-pane label="优惠券使用记录导出" name="kaquan_user_log"></el-tab-pane>
      <el-tab-pane label="第三方对账明细" name="account_checking_data"></el-tab-pane>
      <el-tab-pane label="第三方账单汇总" name="billing_merchant_total_data"></el-tab-pane>
      <el-tab-pane label="第三方商家汇总" name="billing_total_data"></el-tab-pane>
      <el-tab-pane label="企业成员导出" name="employee_data"></el-tab-pane>
      <el-tab-pane label="报名导出" name="selform_registration_record"></el-tab-pane>
      <el-tab-pane label="商保订单导出" name="order_sync"></el-tab-pane>
      <el-tab-pane label="新增保额数据导出" name="sum_amount_data"></el-tab-pane>
      <el-tab-pane label="众安用户卡券" name="user_card"></el-tab-pane>
      <el-tab-pane label="众安财务对账" name="caiwu_duizhang"></el-tab-pane>
      <el-tab-pane label="第三方来源" name="third_jump"></el-tab-pane>
      <el-tab-pane label="人保会员" name="renbao_user"></el-tab-pane>
      <el-tab-pane label="水滴会员" name="sdbao_user"></el-tab-pane>
      <el-tab-pane label="全民会员" name="qmbao_user"></el-tab-pane>
      <el-tab-pane label="积分商品" name="jfsc_goods"></el-tab-pane>
      <el-tab-pane label="积分订单" name="jfsc_order"></el-tab-pane>
      <el-tab-pane label="签到列表" name="members_signin_log"></el-tab-pane>
      <el-tab-pane label="签到奖励列表" name="members_signin_award"></el-tab-pane>
      <el-table :data="exportLogLists" :height="wheight-220" v-loading="loading">
        <el-table-column prop="log_id" label="ID" width="80"></el-table-column>
        <el-table-column prop="file_name" label="文件名称"></el-table-column>
        <el-table-column prop="finish_date" label="处理完成时间" width="160"> </el-table-column>
        <el-table-column prop="handle_status" label="处理状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.handle_status == 'wait'">等待处理</span>
            <span v-if="scope.row.handle_status == 'finish'">处理完成</span>
            <span v-if="scope.row.handle_status == 'processing'">处理中</span>
            <span v-if="scope.row.handle_status == 'fail'">处理失败</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="150" fixed="right">
          <template slot-scope="scope">
            <a :href="scope.row.file_url" download target="_blank">下载</a>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
        <el-pagination
        background
        layout="prev, pager, next, total"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { ExportLogList } from '../../../api/trade'
  export default {
    props: ['getStatus'],
    data () {
      return {
        activeName:"member",
        create_time: '',
        exportLogLists: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
          export_type: '',
          time_start_begin: '',
          time_start_end: '',
        },
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      // 切换tab
      handleClick(tab, event) {
        this.activeName = tab.name
        this.params.page = 1
        this.getExportLogLists(this.params)
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getExportLogLists(this.params)
      },
      dataSearch() {
        this.params.page = 1
        this.getExportLogLists(this.params)
      },
      getExportLogLists (params) {
        this.loading = true
        params.export_type = this.activeName
        ExportLogList(params).then(response => {
          this.exportLogLists = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
      },
      dateChange (val) {
        if (val && val.length > 0) {
          this.params.start_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.params.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
          this.params.start_time = ''
          this.params.end_time = ''
        }
        this.params.page = 1
        this.getExportLogLists(this.params)
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
    },
    mounted () {
      this.getExportLogLists(this.params)
    },
    watch: {
      getStatus (val) {
        if (val) {
          this.getExportLogLists(this.params)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .text-muted {
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// index.vue?4931c01c